var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box_title px-5 py-3"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n  ")]),_c('div',[_vm._t("default",[_c('p',{staticStyle:{"min-height":"80px"}},[_vm._v("Content Goes Here")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }